import { types } from 'mobx-state-tree';
import { callAgroApi } from '@services/agroapi';
import { translateList } from '@services/utils';
import { ActivityType } from './ActivityType';
import { ActivityTypeResponse } from '@services/responseTypes';
import { Transformers } from '@services/transformer';
export const ActivityTypeStore = types.model('ActivityTypeStore', {
  activityTypes: types.array(ActivityType)
}).views(self => ({
  get activityTypeList() {
    const activityTypes = self.activityTypes.map(actType => ({
      label: actType.canonical_name,
      value: actType.id,
      canonical_name: actType.canonical_name
    }));
    const translated = translateList(activityTypes, 'activityType');
    translated.push(translated.splice(translated.indexOf(translated.find(a => a.canonical_name === 'other')!), 1)[0]);
    return translated;
  },
  get fertilizationActivity() {
    return self.activityTypes.find(a => a.canonical_name === 'fertilization')?.id;
  },
  get soilObservationActivity() {
    return self.activityTypes.find(a => a.canonical_name === 'soil_observation')?.id;
  },
  get actTypeIds() {
    return self.activityTypes.reduce((acc, n) => {
      acc[n.id] = true;
      return acc;
    }, {});
  }
})).actions(self => ({
  pushActivityType(activity) {
    !self.actTypeIds[activity.id] && self.activityTypes.push(activity);
    return activity;
  }
})).actions(self => ({
  fetchActivityTypes() {
    return callAgroApi<ActivityTypeResponse[]>('/activity_types', 'GET').then(response => {
      if (response.data) {
        response.data.map(x => self.pushActivityType(Transformers.activityType(x)));
      }
      return self.activityTypes;
    });
  },
  fetchActivityType(id: string) {
    return callAgroApi<ActivityTypeResponse>(`/activity_types/${id}`, 'GET').then(({
      data
    }) => self.pushActivityType(Transformers.activityType(data)));
  }
}));
export const activityTypeStore = ActivityTypeStore.create({
  activityTypes: []
});